import React, { useEffect, useState } from 'react';

// Палитра запасного аватара. Цвет выбирается по email, поэтому у одного человека он
// одинаковый везде: в шапке, в списке аккаунтов и в способах входа.
const COLORS = [
    '#0f9b8e', '#2563eb', '#7c3aed', '#db2777',
    '#ea580c', '#ca8a04', '#16a34a', '#0891b2',
];

const pickColor = (seed) => {
    const key = (seed || '').trim().toLowerCase();
    let hash = 0;
    for (let i = 0; i < key.length; i += 1) {
        hash = (hash * 31 + key.charCodeAt(i)) | 0;
    }
    return COLORS[Math.abs(hash) % COLORS.length];
};

const initials = (name, email) => {
    const source = (name || '').trim() || (email || '').trim();
    if (!source) return '?';

    // Из «Имя Фамилия» берём две буквы, из адреса почты - одну: у адреса вторым словом
    // обычно оказывается домен, и «CM» вместо «C» ничего о владельце не говорит.
    const words = source.split(/[\s._-]+/).filter(Boolean);
    if (!name && email) return words[0][0].toUpperCase();
    if (words.length === 1) return words[0][0].toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
};

/**
 * Аватар пользователя: картинка, а если её нет - инициалы на цветном круге.
 *
 * <p>Инициалы рисуются здесь, а не запрашиваются у внешнего сервиса: аватар есть на
 * каждой странице портала, и подставлять туда чужой домен значит показывать пустое место
 * ровно тогда, когда этот домен недоступен.
 *
 * <p>Сломанная ссылка на картинку приводит к тому же запасному виду: аватар мог остаться
 * от провайдера, который её с тех пор удалил.
 */
const Avatar = ({ src, name, email, size = 40, className = '', textClassName = '' }) => {
    const [failed, setFailed] = useState(false);

    // Загрузили новый аватар - прежняя ошибка к нему не относится.
    useEffect(() => setFailed(false), [src]);

    const style = { width: size, height: size };

    if (src && !failed) {
        return (
            <img
                src={src}
                alt=""
                style={style}
                className={`rounded-full object-cover bg-gray-100 shrink-0 ${className}`}
                onError={() => setFailed(true)}
            />
        );
    }

    return (
        <div
            style={{ ...style, backgroundColor: pickColor(email || name), fontSize: Math.round(size * 0.4) }}
            className={`rounded-full shrink-0 flex items-center justify-center text-white font-semibold select-none ${className} ${textClassName}`}
            aria-hidden="true"
        >
            {initials(name, email)}
        </div>
    );
};

export default Avatar;
